<div class="layout-content">
  <header class="layout-content__header">
    <ofi-foundation-header
      [username]="username"
      [visibility]="visibility"
      [menuButtonCB]="menuButtonCB"
    ></ofi-foundation-header>
    <ng-content select=".body-content"></ng-content>
  </header>

  <main class="layout-content__main">
    <div class="navigation-row">
      <button
        ejs-button
        class="e-flat back ofi-secondary-action"
        iconCss="material-icons ofi-icon-arrow-back"
        iconPosition="Left"
        (click)="back()"
      >
        Back
      </button>
      <a *ngIf="practice | async as p" [href]="p.href">GO TO {{ p.name }}</a>
    </div>
    <ng-content select=".body-content"></ng-content>
    <router-outlet></router-outlet>
  </main>

  <footer class="layout-content__footer">
    <ng-content select=".footer-content"></ng-content>
    <ofi-foundation-footer></ofi-foundation-footer>
  </footer>
</div>
